import styled, { css } from "styled-components";
import { lighten } from "polished";
import { IStyleProps, IStyledWhiteButtonProps, IStyledBlackButtonProps } from "./interfaces";

export const lowDim = 0.62;
export const width = 100;
const height = 200;
const blackWidth = width * 0.6;

export const StyledKeyboard = styled.div<IStyleProps>`
    height: ${p => height * (p.isLow ? lowDim : 1)}px;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;

    &::-webkit-scrollbar {
        width: 8px;
        height: 6px;
        padding-top: 2px;
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${p => lighten(0.1, p.theme.c.pale)};
    }
`;

export const StyledWhiteButtonWrapper = styled.div<IStyleProps>`
    height: ${p => height * (p.isLow ? lowDim : 1) - 8}px;
    width: ${p => width * (p.isLow ? lowDim : 1)}px;
    display: inline-block;
    position: relative;
    text-align: center;
    ${p =>
        p.isLow
            ? css`
                  margin-right: -1px;
              `
            : undefined}
`;

const pulsatePiano = css`
    @keyframes PulsatePiano {
        0% {
            transform: scale(0.96, 0.96) translateY(-4px);
        }
        50% {
            transform: scale(1, 1);
        }
        100% {
            transform: scale(0.96, 0.96) translateY(-4px);
        }
    }
    &.PulsatePiano {
        animation: PulsatePiano 2s infinite;
    }
`;

export const StyledWhiteButton = styled.button<IStyledWhiteButtonProps>`
    height: ${p => height * (p.isLow ? lowDim : 1) - 8}px;
    width: ${p => width * (p.isLow ? lowDim : 1)}px;
    border: black solid 2px;
    background-color: white;
    box-sizing: border-box;
    cursor: pointer;
    padding-top: ${p => 132 * (p.isLow ? lowDim : 1)}px;
    font-size: ${p => 25 * (p.isLow ? lowDim : 1)}px;
    user-select: none;
    border-radius: 0 0 16px 16px;
    color: black;
    outline: none;
    ${p =>
        p.disabled &&
        css`
            pointer-events: none;
            background-color: #e4edec;
            color: transparent;
        `}
    &:active {
        background-color: ${p => p.theme.c.info};
        color: white;
    }
    ${p =>
        p.selected &&
        css`
            background-color: ${p => p.theme.c.info};
            color: white;
        `}
    ${pulsatePiano}
`;

export const StyledBlackButton = styled.button<IStyledBlackButtonProps>`
    position: absolute;
    left: ${p => width * (p.isLow ? lowDim : 1) - (blackWidth * (p.isLow ? lowDim : 1)) / 2}px;
    ${p =>
        p.left &&
        css`
            margin-left: -6px;
        `}
    ${p =>
        p.right &&
        css`
            margin-left: 6px;
        `}
    width: ${p => blackWidth * (p.isLow ? lowDim : 1)}px;
    height: ${p => height * (p.isLow ? lowDim : 1) * 0.55}px;
    border-radius: 0 0 8px 8px;
    top: 0;
    outline: none;
    z-index: 1;
    background-color: #008d82;
    border: 2px solid black;
    box-sizing: border-box;
    font-size: ${p => 25 * (p.isLow ? lowDim : 1)}px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 12px;
    color: ${p => p.theme.c.snow};
    ${p =>
        p.disabled &&
        css`
            background-color: #99cac6;
            color: transparent;
        `}
    ${p =>
        !p.disabled &&
        css`
            cursor: pointer;
            &:active {
                background-color: ${p => p.theme.c.info};
            }
            ${p.selected &&
            css`
                background-color: ${p.theme.c.info};
            `}
        `}
    ${pulsatePiano}
`;

export const StyledOctave = styled.div`
    display: inline-block;
    vertical-align: top;
`;
